// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"86551bea","224":"54b66f60","374":"d0e0ae26","382":"71f792d8","478":"a004032d","659":"6dc7a6b2"}[chunkId] + ".chunk.js";
};